<div class="protocol-container">
    <h3 *ngIf="editMode">{{ 'COMPLAINT_APPOINTMENT|Protokół' | translate }}</h3>

    <div>
        <div class="protocol-data">
            <span class="protocol-date">{{ 'COMPLAINT_APPOINTMENT|Data protokołu:' | translate }} {{ complaintAppointment.protocolDate ? (complaintAppointment.protocolDate | date: 'shortDate') : currentDate | date: 'shortDate' }}</span>
            <span class="protocol-complaint-number">{{ 'COMPLAINT_APPOINTMENT|Numer reklamacji:' | translate }} {{ complaint.documentNumber?.join('') }}</span>
            <div class="protocol-client-details">
                <span>{{ 'COMPLAINT_APPOINTMENT|Dane klienta:' | translate }}</span>
                <span>{{ 'PERSON|Imię i nazwisko: {clientName}' | translate: { clientName: complaint.clientName } }}</span>
                <span>{{ 'CONTACT|Email: {clientEmail}' | translate: { clientEmail: complaint.clientEmail } }}</span>
                <span>{{ 'CONTACT|Telefon: {clientPhoneNumber}' | translate: { clientPhoneNumber: complaint.clientPhoneNumber } }}</span>
                <span>{{ 'COMPLAINT_APPOINTMENT|Adres instalacji: {installationAddress}' | translate: { installationAddress: complaint.installationAddress } }}</span>
            </div>
        </div>

        <div class="protocol-questions">
            <h3 style="text-align: center;">{{ 'COMPLAINT_APPOINTMENT|Wypełnia serwis' | translate }}</h3>
            <div *ngIf="!complaintAppointment.servicemanSignatureImage && (complaintAppointment.wingDamages || complaintAppointment.doorMeasurement) && !complaintAppointmentAttachments.length" class="protocol-questions__validation-info">{{ 'COMPLAINT_APPOINTMENT|Uwaga! Zaznaczyłeś opcje, które wymagają dodania zdjęcia do protokołu. Dodaj zdjęcie, aby móc przejść dalej.' | translate }}</div>
            <div class="protocol-questions__checkbox">
                <icc-checkbox
                    [name]="'orderCompliance'"
                    [(ngModel)]="complaintAppointment.orderCompliance"
                    (change)="complaintAppointment.orderCompliance = $event.checked"
                    [disabled]="clientView"
                >
                    {{ 'COMPLAINT_APPOINTMENT|Zgodność z zamówieniem' | translate }}
                </icc-checkbox>
            </div>
            <div class="protocol-questions__checkbox">
                <icc-checkbox
                    [name]="'wingDamages'"
                    [(ngModel)]="complaintAppointment.wingDamages"
                    (change)="complaintAppointment.wingDamages = $event.checked"
                    [disabled]="clientView"
                >
                    {{ 'COMPLAINT_APPOINTMENT|Czy skrzydło posiada uszkodzenia jakiekolwiek? (jeśli tak, to należy wykonać zdjęcia)' | translate }}
                </icc-checkbox>
            </div>
            <div class="protocol-questions__checkbox">
                <icc-checkbox
                    [name]="'roof'"
                    [(ngModel)]="complaintAppointment.roof"
                    (change)="complaintAppointment.roof = $event.checked"
                    [disabled]="clientView"
                >
                    {{ 'COMPLAINT_APPOINTMENT|Czy jest zadaszenie?' | translate }}
                </icc-checkbox>
            </div>
            <div class="protocol-questions__checkbox">
                <icc-checkbox
                    [name]="'properDoorLocking'"
                    [(ngModel)]="complaintAppointment.properDoorLocking"
                    (change)="complaintAppointment.properDoorLocking = $event.checked"
                    [disabled]="clientView"
                >
                    {{ 'COMPLAINT_APPOINTMENT|Poprawne kluczenie drzwi - sprawdzenie' | translate }}
                </icc-checkbox>
            </div>
            <div class="protocol-questions__checkbox">
                <icc-checkbox
                    [name]="'doorAdjustment'"
                    [(ngModel)]="complaintAppointment.doorAdjustment"
                    (change)="complaintAppointment.doorAdjustment = $event.checked"
                    [disabled]="clientView"
                >
                    {{ 'COMPLAINT_APPOINTMENT|Regulacja drzwi' | translate }}
                </icc-checkbox>
            </div>
            <div class="protocol-questions__checkbox">
                <icc-checkbox
                    [name]="'doorMeasurement'"
                    [(ngModel)]="complaintAppointment.doorMeasurement"
                    (change)="complaintAppointment.doorMeasurement = $event.checked"
                    [disabled]="clientView"
                >
                    {{ 'COMPLAINT_APPOINTMENT|Pomiar drzwi (pion ościeżnicy / wymiary skrzydła / ugięcie skrzydła / wybrzuszenie)' | translate }}
                </icc-checkbox>
            </div>
        </div>

        <div *ngIf="editMode && !clientView" class="appointment-protocol__input">
            <icc-input
                type="textarea"
                [name]="'protocolChangedPartsOrActions'"
                [value]="complaintAppointment.protocolChangedPartsOrActions"
                [size]="'large'"
                [required]="true"
                [minLength]="10"
                (valueChange)="complaintAppointment.protocolChangedPartsOrActions = $event"
                [prefixIcon]="'edit'"
                [rows]="7"
                [cols]="80"
                [placeholder]="'COMPLAINT_APPOINTMENT|Wymienione części/czynności serwisowe (jakie?)' | translate"
                [label]="'COMPLAINT_APPOINTMENT|Wymienione części/ czynności serwisowe (jakie?)' | translate"
                [requiredErrorMessage]="('INTERFACE|To pole jest wymagane' | translate)"
                [minLengthErrorMessage]="('INTERFACE|Minimalna długość to 10 znaków' | translate)"
                class="textarea-resizable"
            ></icc-input>
        </div>

        <div *ngIf="clientView" class="appointment-protocol__changed-parts-or-actions">
            <h3>{{ 'COMPLAINT_APPOINTMENT|Wymienione części/czynności serwisowe (jakie?)' | translate }}</h3>

            <p class="content-text">
                {{ complaintAppointment.protocolChangedPartsOrActions ? complaintAppointment.protocolChangedPartsOrActions : 'COMPLAINT_APPOINTMENT|Brak' | translate }}
            </p>
        </div>

        <div *ngIf="editMode && !clientView" class="appointment-protocol__input">
            <icc-input
                type="textarea"
                [name]="'protocolNotes'"
                [value]="complaintAppointment.protocolNotes"
                [size]="'large'"
                [required]="false"
                (valueChange)="complaintAppointment.protocolNotes = $event"
                [prefixIcon]="'edit'"
                [rows]="7"
                [cols]="80"
                [placeholder]="'COMPLAINT_APPOINTMENT|Uwagi serwisanta' | translate"
                [label]="'COMPLAINT_APPOINTMENT|Uwagi serwisanta' | translate"
                class="textarea-resizable"
            ></icc-input>
        </div>

        <div *ngIf="clientView" class="appointment-protocol__content">
            <h3>{{ 'COMPLAINT_APPOINTMENT|Uwagi serwisanta' | translate }}</h3>

            <p class="content-text">
                {{ complaintAppointment.protocolNotes ? complaintAppointment.protocolNotes : 'COMPLAINT_APPOINTMENT|Brak' | translate }}
            </p>
        </div>
    </div>

    <h3>{{ 'COMPLAINT_APPOINTMENT|Zdjęcia' | translate }}</h3>
    <div *ngIf="editMode && !clientView" class="protocol__attachment">
        <label [for]="'additionalProtocolFile' + complaintAppointment.uuid" style="cursor: pointer;">
            <icc-icon name="add_photo"></icc-icon>{{ ('INTERFACE|Dodaj' | translate) }}
        </label>
        <input
            type="file"
            [required]="true"
            [id]="'additionalProtocolFile' + complaintAppointment.uuid"
            (change)="onAddAttachment($event.target.files, 'additionalProtocolFile')"
        >
        <p *ngIf="additionalProtocolFileError" class="invalid-message">{{ additionalProtocolFileError }}</p>
        <div *ngIf="!complaintAppointment.servicemanSignatureImage && (complaintAppointment.wingDamages || complaintAppointment.doorMeasurement) && !complaintAppointmentAttachments.length" class="photo-required">{{ 'COMPLAINT_APPOINTMENT|Wymagane dodanie zdjęcia' | translate }}</div>
    </div>
    <div *ngIf="getAttachments('additionalProtocolFile')" class="details-card protocol-attachments">
        <div class="details-card-body" *ngFor="let additionalProtocolFile of additionalProtocolFiles; index as i">
            <div class="image-container">
                <a
                    *ngIf="getAttachment('additionalProtocolFile')"
                    [href]="'/complaint_attachments/' + additionalProtocolFile.uuid"
                    target="_blank"
                >
                    <img
                        [src]="additionalProtocolFile.preview"
                        [alt]="additionalProtocolFile.name"
                    >
                </a>
            </div>
            <div>
                <icc-icon *ngIf="editMode && !clientView" name="delete" (click)="removeAttachment('additionalProtocolFile', additionalProtocolFile.uuid)"></icc-icon>
            </div>
        </div>
    </div>
    <div *ngIf="(getAttachments('additionalProtocolFile').length < 1) && !editMode" class="details-card protocol-attachments">
        <span style="margin-left: 16px;">{{ 'INTERFACE|Brak' | translate }}</span>
    </div>

    <mat-divider class="divider"></mat-divider>

    <div class="protocol-repair-type">
        <div class="protocol-repair-type__checkbox">
            <icc-checkbox
                [name]="'protocol-repair-type'"
                [(ngModel)]="complaintAppointment.paidService"
                (change)="complaintAppointment.paidService = $event.checked"
                [disabled]="clientView"
            >
                {{ 'COMPLAINT_APPOINTMENT|Usługa płatna' | translate }}
            </icc-checkbox>
        </div>
    </div>

    <ng-container *ngIf="complaintAppointment.paidService && editMode && !clientView">
        <div class="protocol-repair-cost">
            <icc-input
                type="number"
                [name]="'protocol-repair-cost'"
                [step]="0.01"
                [value]="complaintAppointment.repairCost"
                [size]="'medium'"
                [required]="false"
                (valueChange)="complaintAppointment.repairCost = $event"
                [prefixIcon]="'shopping_cart'"
                [placeholder]="'COMPLAINT_APPOINTMENT|Kwota naprawy' | translate"
                [suffix]="'zł'"
                [label]="'COMPLAINT_APPOINTMENT|Kwota naprawy' | translate"
            ></icc-input>
        </div>
    </ng-container>

    <div *ngIf="complaintAppointment.paidService && clientView" class="appointment-protocol__repair-cost">
        <span>{{ 'COMPLAINT_APPOINTMENT|Kwota naprawy: {repairCost} zł' | translate: { repairCost: complaintAppointment.repairCost } }}</span>
    </div>

    <h3>{{ 'COMPLAINT_APPOINTMENT|Status prac' | translate }}</h3>
    <div class="protocol-work-status">
        <div class="protocol-work-status__radio">
            <icc-radio
                name="protocol-work-status"
                [value]="'completed'"
                [checked]="complaintAppointment.workStatus === 'completed'"
                [(ngModel)]="complaintAppointment.workStatus"
                [disabled]="clientView"
            >
                {{ 'COMPLAINT_APPOINTMENT|Zakończone' | translate }}
            </icc-radio>
        </div>
        <div class="protocol-work-status__radio">
            <icc-radio
                name="protocol-work-status"
                [value]="'inProgress'"
                [checked]="complaintAppointment.workStatus === 'inProgress'"
                [(ngModel)]="complaintAppointment.workStatus"
                [disabled]="clientView"
            >
                {{ 'COMPLAINT_APPOINTMENT|Niezakończone' | translate }}
            </icc-radio>
        </div>
        <div class="protocol-work-status__radio">
            <icc-radio
                name="protocol-work-status"
                [value]="'rejected'"
                [checked]="complaintAppointment.workStatus === 'rejected'"
                [(ngModel)]="complaintAppointment.workStatus"
                [disabled]="clientView"
            >
                {{ 'COMPLAINT_APPOINTMENT|Reklamacja niezasadna - odrzucona' | translate }}
            </icc-radio>
        </div>
        <ng-container *ngIf="complaintAppointment.workStatus === 'inProgress'">
            <div *ngIf="editMode && !clientView" class="protocol-work-status__work-to-do">
                <icc-input
                    type="textarea"
                    [name]="'protocol-work-to-do'"
                    [value]="complaintAppointment.workToDo"
                    [size]="'large'"
                    [required]="false"
                    (valueChange)="complaintAppointment.workToDo = $event"
                    [prefixIcon]="'edit'"
                    [rows]="7"
                    [cols]="80"
                    [placeholder]="'COMPLAINT_APPOINTMENT|Co jest jeszcze do zrobienia?' | translate"
                    [label]="'COMPLAINT_APPOINTMENT|Co jest jeszcze do zrobienia?' | translate"
                    class="textarea-resizable"
                ></icc-input>
            </div>

            <div *ngIf="clientView" class="appointment-protocol__work-to-do">
                <h3>{{ 'COMPLAINT_APPOINTMENT|Co jest jeszcze do zrobienia?' | translate }}</h3>

                <p class="content-text">
                    {{ complaintAppointment.workToDo }}
                </p>
            </div>
        </ng-container>
    </div>

    <div class="protocol-client-view" *ngIf="clientView">
        <h3 style="text-align: center;">{{ 'COMPLAINT_APPOINTMENT|Wypełnia klient' | translate }}</h3>
        <div *ngIf="editMode && !clientSigned" class="appointment-protocol__input">
            <icc-input
                type="textarea"
                [name]="'protocolUserNotes'"
                [value]="complaintAppointment.protocolUserNotes"
                [size]="'large'"
                [required]="false"
                (valueChange)="complaintAppointment.protocolUserNotes = $event"
                [prefixIcon]="'edit'"
                [rows]="7"
                [cols]="80"
                [placeholder]="'COMPLAINT_APPOINTMENT|Uwagi użytkownika (wypełnia klient)' | translate"
                [label]="'COMPLAINT_APPOINTMENT|Uwagi użytkownika (wypełnia klient)' | translate"
                class="textarea-resizable"
            ></icc-input>
        </div>

        <div *ngIf="(clientView && !editMode) || clientSigned" class="appointment-protocol__work-to-do">
            <h3>{{ 'COMPLAINT_APPOINTMENT|Uwagi użytkownika' | translate }}</h3>

            <p class="content-text">
                {{ complaintAppointment.protocolUserNotes ? complaintAppointment.protocolUserNotes : 'INTERFACE|Brak' | translate }}
            </p>
        </div>

        <div *ngIf="editMode && !clientSigned" class="appointment-protocol__select">
            <icc-select
                name="serviceRating"
                [value]="complaintAppointment.serviceRating"
                (valueChange)="complaintAppointment.serviceRating = $event"
                [label]="'COMPLAINT_APPOINTMENT|Ocena serwisu' | translate"
                size="medium"
                [required]="false"
                [prefixIcon]="'done'"
                appearance="outline"
                [treatDefaultOptionAsValue]="true"
                [supportText]="('COMPLAINT_APPOINTMENT|1 - najniższa, 10 - najwyższa' | translate)"
            >
                <option value="0" disabled>{{ 'INTERFACE|Nie wybrano' | translate }}</option>
                <option
                    *ngFor="let rating of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
                    [value]="rating"
                >
                    {{ rating }}
                </option>
            </icc-select>
        </div>

        <div *ngIf="(clientView && !editMode) || clientSigned">
            <h3>{{ complaintAppointment.serviceRating !== 0 ? ('COMPLAINT_APPOINTMENT|Ocena serwisu: {serviceRating}' | translate: { serviceRating: complaintAppointment.serviceRating }) : ('COMPLAINT_APPOINTMENT|Ocena serwisu: nie wybrano' | translate) }}</h3>
        </div>
    </div>
</div>
